import { useCallback, useMemo } from 'react';
import { useQuery, useMutation } from '@ts-core/lib/apollo';

import { getErrorMessage, useMutationCompletionHandler } from '@ts-core/lib/apollo';

import { getStudentsByCourseQuery } from '../graphql/queries';
import { removeStudentFromCourseMutation, removeAllStudentsFromCourseMutation } from '../graphql/mutations';

export default function useStudents({ courseId }) {
  const { onError, removeItemFromCache } = useMutationCompletionHandler();

  const { data, loading, error, refetch } = useQuery(getStudentsByCourseQuery, {
    variables: { courseId },
    skip: !courseId,
    fetchPolicy: 'cache-and-network',
  });
  const students = useMemo(() => data?.students || [], [data]);

  /**
   * Remove student from course
   */
  const [removeStudent] = useMutation(removeStudentFromCourseMutation, {
    onError,
    update: removeItemFromCache({
      query: getStudentsByCourseQuery,
      variables: { courseId },
      queryField: 'students',
      mutationField: 'student',
    }),
  });
  const onRemoveStudent = useCallback(
    (student) => {
      removeStudent({
        variables: {
          courseId,
          studentId: student._id,
        },
        optimisticResponse: {
          student,
        },
      });
    },
    [removeStudent, courseId]
  );

  /**
   * Remove all students
   */
  const [removeAllStudents, { loading: removingAllStudents }] = useMutation(removeAllStudentsFromCourseMutation, {
    onError,
    refetchQueries: refetch,
  });
  const onRemoveAllStudents = useCallback(() => {
    removeAllStudents({ variables: { courseId } });
  }, [courseId, removeAllStudents]);

  return {
    students,
    loading,
    error: getErrorMessage({ error }),

    refetch,
    onRemoveStudent,

    onRemoveAllStudents,
    removingAllStudents,
  };
}
